import { isoAlpha3ToAlpha2 } from "./isoAlpha3ToAlpha2";

// Convert Alpha-3 to Alpha-2
export function convertAlpha3ToAlpha2(alpha3: string): string | null {
  const code = String(alpha3).toUpperCase();
  return isoAlpha3ToAlpha2[code] || null;
}
// export function checkMVCHost(): boolean {
//   const host = window.location.host;
//   //return host === "owners.marriottvacationclub.com"|| host==="mfees.marriottvacationclub.com"?true:false
// return true;


// }
// Generic helper to retrieve and clean a session variable

function getStoredValue(key: string) {
  let value = sessionStorage.getItem(key);

  if (!value) return null;

  // Remove wrapping quotes if they exist

  return value.replace(/^"(.*)"$/, "$1");
}

// Generic helper to retrieve and clean a session variable

// Specific helper functions for each session variable
export function getStoredEmail() {
  return getStoredValue("profileInfoEmail");
}
export function getStoredScreenType(){
  return getStoredValue("SCREEN_TYPE");
}
export function getStoredCorrelation(){
  return getStoredValue("X_CORRELATION_ID");
}
export function getStoredCountry() {
  return getStoredValue("profileInfoCountry");
}

export function getStoredFirstName() {
  return getStoredValue("profileInfoFirstName");
}

export function getStoredLastName() {
  return getStoredValue("profileInfoLastName");
}



function getCookie(name: string) {
  // Construct the name pattern to search for
  let nameEQ = name + "=";
  // Split the document.cookie string into individual cookies
  let ca = document.cookie.split(";");
  // Loop through each cookie
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    // Remove leading spaces
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    // Check if the cookie starts with the name pattern
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  // Return null if the cookie is not found
  return null;
}

export function getLanguagePreference() {
  var lang = getCookie("langPref");
  console.log("LANG:", lang);
  return lang === "oljs_default" ? "en" : lang;
}

